<template>
  <ul class="feature-list">
    <li v-for="(feature, k) in data" :key="k">
      <span v-if="feature.attributes">{{ feature.attributes.name }}</span>
      <span v-else>{{ feature }}</span>
    </li>
  </ul>
</template>

<script>
export default {
  name: "Features",
  props: {
    data: {
      type: Array,
      default() {
        return ["Default"];
      }
    }
  }
};
</script>

<style lang="scss">
.feature-list {
  list-style: none;
  padding: 0;
  margin: 0;
  width: 100%;

  overflow-x: scroll;
  overflow-y: hidden;
  white-space: nowrap;

  li {
    background: $white;
    font-size: 16px;
    line-height: 25px;
    font-weight: 600;
    text-transform: uppercase;
    display: inline-block;
    margin: 0 8px 8px 0;
    padding: 8px 10px 2px 10px;
    border-radius: 4px;
  }

  @media screen and (min-width: $breakpoint) {
    overflow: hidden;
    white-space: normal;
  }
}
</style>
